import { trans } from '@spotahome/soyuz/client';

import MarkerIcon from '@spotahome/landings-common/src/components/icons/MakerIcon';
import EnvelopeIcon from '@spotahome/landings-common/src/components/icons/EnvelopeIcon';
import CheckedIcon from '@spotahome/landings-common/src/components/icons/CheckedIcon';
import KeyIcon from '@spotahome/landings-common/src/components/icons/KeyIcon';

import './HiwContentRedesign.scss';

const sections = {
  step1: 'search-and-select',
  step2: 'reserve-the-property',
  step3: 'confirmation',
  step4: 'move-in'
};

const HiwContentRedesign = () => {
  const howItWorksStep2TextKey = 'how_it_works.alt.step2.no_blocking.text';

  return (
    <div className="hiw-wrapper-redesign">
      <div className="hiw-container-redesign" id={sections.step1}>
        <MarkerIcon className="hiw-container-redesign__image" />
        <div className="hiw-container-redesign__section-wrapper">
          <h3 className="hiw-container-redesign__title">
            1. {trans('how_it_works.alt.step1.title')}
          </h3>
          <div>
            <p className="hiw-container-redesign__main-text">
              {trans('how_it_works.alt.step1.text')}
            </p>

            <div className="hiw-container-redesign__block-wrapper">
              <div className="hiw-container-redesign__info-wrapper hiw-container-redesign__info-wrapper--mr">
                <h4 className="hiw-container-redesign__underlined-title">
                  {trans('how_it_works.alt.step1.block1.title')}
                </h4>
                <p className="hiw-container-redesign__block-text">
                  {trans('how_it_works.alt.step1.block1.text')}
                </p>
              </div>
              <div className="hiw-container-redesign__info-wrapper">
                <h4 className="hiw-container-redesign__underlined-title">
                  {trans('how_it_works.alt.step1.block2.title')}
                </h4>
                <p className="hiw-container-redesign__block-text">
                  {trans('how_it_works.alt.step1.block2.text')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="hiw-container-redesign" id={sections.step2}>
        <EnvelopeIcon className="hiw-container-redesign__image" />
        <div className="hiw-container-redesign__section-wrapper">
          <h3 className="hiw-container-redesign__title">
            2. {trans('how_it_works.alt.step2.title')}
          </h3>
          <div>
            <p className="hiw-container-redesign__main-text">
              {trans(howItWorksStep2TextKey)}
            </p>

            <div className="hiw-container-redesign__block-wrapper">
              <div className="hiw-container-redesign__info-wrapper">
                <h4 className="hiw-container-redesign__underlined-title hiw-container-redesign__underlined-title--full">
                  {trans('how_it_works.alt.step2.block1.title')}
                </h4>
                <div className="hiw-container-redesign__divided">
                  <p className="hiw-container-redesign__block-text">
                    <strong>
                      {trans('how_it_works.alt.step2.block1.text1.strong')}
                    </strong>{' '}
                    {trans('how_it_works.alt.step2.block1.text1')}
                  </p>
                  <p className="hiw-container-redesign__block-text">
                    <strong>
                      {trans('how_it_works.alt.step2.block2.text2.strong')}
                    </strong>{' '}
                    {trans('how_it_works.alt.step2.block2.text2')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="hiw-container-redesign" id={sections.step3}>
        <CheckedIcon className="hiw-container-redesign__image" />
        <div className="hiw-container-redesign__section-wrapper hiw-container-redesign__section-wrapper--more-pb">
          <h3 className="hiw-container-redesign__title">
            3. {trans('how_it_works.alt.step3.title')}
          </h3>
          <div>
            <p className="hiw-container-redesign__main-text">
              {trans('how_it_works.alt.step3.text')}
            </p>

            <div className="hiw-container-redesign__block-wrapper">
              <div className="hiw-container-redesign__info-wrapper--mr">
                <h4 className="hiw-container-redesign__underlined-title">
                  {trans('how_it_works.alt.step3.block1.title')}
                </h4>
                <p className="hiw-container-redesign__block-text hiw-container-redesign__block-text--step3">
                  {trans('how_it_works.alt.step3.block1.text')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="hiw-container-redesign hiw-container-redesign--last"
        id={sections.step4}
      >
        <KeyIcon className="hiw-container-redesign__image" />
        <div className="hiw-container-redesign__section-wrapper hiw-container-redesign__section-wrapper--last">
          <h3 className="hiw-container-redesign__title">
            4. {trans('how_it_works.alt.step4.title')}
          </h3>
          <p className="hiw-container-redesign__main-text mb-halve">
            {trans('how_it_works.alt.step4.text1')}
          </p>
          <p className="hiw-container-redesign__main-text">
            {trans('how_it_works.alt.step4.text2')}
          </p>

          <div className="hiw-container-redesign__block-wrapper hiw-container-redesign__block-wrapper--step4">
            <div className="hiw-container-redesign__info-wrapper">
              <h4 className="hiw-container-redesign__underlined-title">
                {trans('how_it_works.alt.step4.block1.title')}
              </h4>
              <p className="hiw-container-redesign__block-text">
                {trans('how_it_works.alt.step4.block1.text')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HiwContentRedesign;
